import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Autocomplete,
  Badge,
  Box,
  Button,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import "./index.scss";
import CustomModal from "../../../common-utilities/core/modal";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { FINANCE_V2_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { FINANCE_REST_URLS } from "../../../common-utilities/utils/end-points/finance-v2";
import GRNList from "./grn-list";
import { isCreateAllowed } from "../../utils/common-utils";
import GRNApprovalList from "./grn-approval-list";
import InvoiceDataList from "../invoices-data/invoice-data-list";
import { checkUserRight } from "../../utils/utils";
import FinancialYearDropdown from "../home/financial-year-dropdown";
import { getOfflineData } from "../../utils/offline-services";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const GoodsReceiveNotes = () => {
  const navigate = useNavigate();
  const [poModal, setPOModal] = useState(false);
  const [isVendorUser, setVendorUser] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const mainTabIndex = searchParams.get("index");
  const openTabIndex = searchParams.get("subIndex");
  const [noOfPendingGrn, setNoOfPendingGrn] = useState(0);
  const [noOfReconsiderGrn, setNoOfReconsiderGrn] = useState(0);
  const [value, setValue] = useState(+openTabIndex || 0);
  const [formDetails, setFormDetails] = useState({});
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const handleChange = (event, newValue) => {
    setSearchParams({
      index: mainTabIndex || 0,
      subIndex: newValue,
    });
    setValue(newValue);
  };

  const onCreate = () => {
    const { po } = formDetails;
    navigate(`grn-order/create/${po.id}`);
  };
  const loadPurchaseOrders = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.PO}`,
      null,
      {
        page: 1,
        limit: 1000,
        sortBy: "-createdAt",
        status: "approved",
        allowInward: true,
        // checkAdvPayment: true,
        isShortClosed: false,
        financialYear: formDetails?.financialYear,
        excludeViewerScope: true,
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setPurchaseOrders(response.results || []);
        }
      })
      .catch((err) => {});
  };
  const getPendingGrn = () => {
    invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GET_MY_APPROVALS}`,
      null,
      {
        approvalType: "invoice_approval",
        invoiceType: "grn_invoice",
        status: "approval_in_progress",
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          setNoOfPendingGrn(response?.length);
        }
      })
      .catch((err) => {});
  };
  const getReconsiderGrn = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GRN_LIST}`,
      null,
      { status: "reconsider", limit: 1000 }
    )
      .then((response) => {
        if (!response.message) {
          setNoOfReconsiderGrn(response?.results?.length || 0);
        }
      })
      .catch((err) => {});
  };
  useEffect(() => {
    const openTabIndex = searchParams.get("subIndex");
    if (+openTabIndex === 5 && !checkUserRight("grn.approveReject")) {
      setValue(4);
    }
  }, []);
  useEffect(() => {
    getReconsiderGrn();
    getPendingGrn();
  }, []);
  useEffect(() => {
    loadPurchaseOrders();
  }, [formDetails?.financialYear]);
  useEffect(() => {
    const user = getOfflineData("user");
    const role = user?.role?.toUpperCase();
    if (role?.includes("VENDOR")) {
      setVendorUser(true);
    }
  }, []);
  return (
    <div className="finance-v2-rm-pt finance-v2-budget-list">
      <div className="tabs-section">
        <Box>
          <Tabs
            variant="scrollable"
            value={value}
            onChange={handleChange}
            sx={{
              borderBottom: "1px solid #DDE2EC",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": {
                color: "#5B6E8A",
                minWidth: "unset",
                borderRadius: "20px",
                margin: "0 2px",
                textTransform: "none",
                "& .MuiBadge-root": {
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                },
                "& .MuiBadge-badge": {
                  position: "relative",
                  transform: "none",
                  top: "auto",
                  right: "auto",
                  background: "transparent",
                  color: "#007A42",
                  minWidth: "unset",
                  height: "auto",
                  padding: 0,
                  fontSize: "0.68rem",
                  fontWeight: 700,
                  lineHeight: 1,
                  borderRadius: 0,
                  boxShadow: "none",
                  "&.MuiBadge-invisible": { display: "none" },
                },
              },
              "& .Mui-selected": {
                color: "#005F35 !important",
                background: "#EAF4EE",
                "& .MuiBadge-badge": {
                  background: "#005F35",
                  color: "#fff",
                  minWidth: "16px",
                  height: "16px",
                  padding: "0 3px",
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  borderRadius: "50%",
                },
              },
            }}
            TabIndicatorProps={{ sx: { display: "none" } }}
          >
            <Tab label="Draft GRN orders" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab label="Open GRN orders" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab label="Approved  GRN orders " sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            <Tab
              label={
                <Badge badgeContent={noOfReconsiderGrn} color="primary">
                  Reconsider GRN orders
                </Badge>
              }
              sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
            />
            <Tab label="All  GRN orders " sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />
            {!isVendorUser && (
              <Tab
                label={
                  <Badge badgeContent={noOfPendingGrn} color="primary">
                    Pending Actions
                  </Badge>
                }
                sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }}
              />
            )}
            {!isVendorUser && <Tab label="Finance" sx={{ paddingX: 3, fontSize: "0.875rem !important", textTransform: "uppercase !important" }} />}
          </Tabs>
        </Box>
        {isCreateAllowed("grn") && (
          <Button
            variant="outlined"
            onClick={() => {
              setPOModal(true);
            }}
          >
            Create GRN
          </Button>
        )}
      </div>
      <TabPanel value={value} index={0}>
        <GRNList status="draft" />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <GRNList status="approval_in_progress" />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <GRNList status="approved" />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <GRNList status="reconsider" />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <GRNList status="all" />
      </TabPanel>
      {!isVendorUser && (
        <TabPanel value={value} index={5}>
          {checkUserRight("grn.approveReject") ? (
            <GRNApprovalList
              approvalType="invoice_approval"
              usedIn="GRN"
              status="approval_in_progress"
            />
          ) : (
            "Not authorized to take action on GRN"
          )}
        </TabPanel>
      )}

      {!isVendorUser && (
        <TabPanel value={value} index={6}>
          {checkUserRight("paymentDetails.view") ? (
            <InvoiceDataList poGrnNo={true} status="approved" usedIn="GRN" />
          ) : (
            "No access to finance"
          )}
        </TabPanel>
      )}

      {poModal && (
        <CustomModal
          title="Create GRN"
          disabledOutsideClick={true}
          onClose={() => {
            setPOModal(false);
          }}
        >
          <div className="finance-v2-po-modal-content">
            <FinancialYearDropdown
              filters={formDetails}
              setFilters={setFormDetails}
              isFullWidth={true}
              disabled={isVendorUser}
            />
            {formDetails?.financialYear && (
              <Autocomplete
                value={formDetails.po || ""}
                onChange={(e, val) => {
                  if (val) {
                    setFormDetails({ po: val });
                  } else {
                    setFormDetails({});
                  }
                }}
                getOptionLabel={(op) => {
                  const { budget } = op;
                  const { siteName } = budget || {};

                  return `${op.poNumber || ""} - ${siteName || ""}` || "";
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Select PO" />
                )}
                options={purchaseOrders}
              />
            )}

            <Button
              variant="outlined"
              onClick={onCreate}
              disabled={!formDetails.po}
            >
              Create Goods Receive Note
            </Button>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default GoodsReceiveNotes;
